import { render, staticRenderFns } from "./EditGeneralMemberView2.vue?vue&type=template&id=83318910&scoped=true&"
import script from "./EditGeneralMemberView2.vue?vue&type=script&lang=js&"
export * from "./EditGeneralMemberView2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83318910",
  null
  
)

export default component.exports